module.exports = __webpack_public_path__ + "static/Inform circle-beeccc77c354485ee74fd75b29fa5ce5.png";